import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import HomePage from "./pages/HomePage";

const AdminRoute = lazy(() => import("./components/routes/AdminRoute"));
const UserRoute = lazy(() => import("./components/routes/UserRoute"));

const LoginPage = lazy(() => import("./pages/LoginPage"));
const StallsPage = lazy(() => import("./pages/stalls/StallsPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/privacy-terms/PrivacyPolicyPage"));
const TermsOfServicePage = lazy(() => import("./pages/privacy-terms/TermsOfServicePage"));
const ProfilePage = lazy(() => import("./pages/profile/ProfilePage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const CashierPage = lazy(() => import("./pages/bills/CashierPage"));
const UserPage = lazy(() => import("./pages/user/UserPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));

function App() {
    return (
        <Layout>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/privacy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms" element={<TermsOfServicePage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />

                    {/* User routes */}

                    <Route
                        path="/profile"
                        element={
                            <UserRoute>
                                <ProfilePage />
                            </UserRoute>
                        }
                    />

                    {/* Admin routes */}
                    <Route
                        path="/stalls"
                        element={
                            <AdminRoute>
                                <StallsPage />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/cashier"
                        element={
                            <AdminRoute>
                                <CashierPage />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/users/:userId"
                        element={
                            <AdminRoute>
                                <UserPage />
                            </AdminRoute>
                        }
                    />

                    {/* 404 page */}
                    <Route path="*" element={<div>Page not found</div>} />
                </Routes>
            </Suspense>
        </Layout>
    );
}

export default App;
